module.exports = __webpack_public_path__ + "img/Kriss.d82965f4.jpg";